const main = () => {
    if (document.querySelector("#zip") === null) return;

    document.getElementById("zip").addEventListener("input", async (e) => {
        let val = e.currentTarget.value;

        // 入力値からハイフンを除去して7桁の数字にする
        const cleanZip = val.replace(/-/g, "");

        // 7桁になった場合に処理を実行
        if (cleanZip.length === 7) {
            // ハイフン付き形式（xxx-xxxx）を作成
            const formattedZip = cleanZip.slice(0, 3) + "-" + cleanZip.slice(3);
            // 現在の入力が自動補完済みでなければ、更新する
            if (val !== formattedZip) {
                val = formattedZip;
            }

            try {
                // APIリクエストはハイフン除去済みの数字を利用
                const response = await fetch(
                    `https://api.zipaddress.net/?zipcode=${cleanZip}`
                );
                const data = await response.json();

                if (data.code === 200) {
                    // 都道府県を選択
                    const prefElement = document.getElementById("pref");
                    // APIから取得した都道府県名と一致する選択肢を探して選択
                    if (prefElement && prefElement.tagName === "SELECT") {
                        const options = Array.from(prefElement.options);
                        const matchOption = options.find(
                            (option) => option.text === data.data.pref
                        );
                        if (matchOption) {
                            prefElement.value = matchOption.value;
                            prefElement.dispatchEvent(new Event("change"));
                        }
                    }

                    // 市区町村をセット
                    const cityElement = document.getElementById("city");
                    if (cityElement) {
                        cityElement.value = data.data.city;
                    }

                    // 丁番地をセット
                    const addressElement = document.getElementById("address");
                    if (addressElement) {
                        addressElement.value = data.data.town;
                    }

                    // 次の入力欄（building）にカーソルを移動
                    const buildingElement = document.getElementById("building");
                    if (buildingElement) {
                        buildingElement.focus();
                        buildingElement.setSelectionRange(
                            buildingElement.value.length,
                            buildingElement.value.length
                        );
                    }
                } else {
                    alert("住所が見つかりませんでした。");
                }
            } catch (error) {
                console.error("エラー:", error);
                alert("住所の取得中にエラーが発生しました。");
            }
        }
    });
};

export default main;
